import React from "react";
import SocialLogin from "react-social-login";
import { FacebookButton } from "./styles";
class SocialButton extends React.Component {
  render() {
    const {
      children,
      triggerLogin,
      dataTestId,
      beforeLogin,
      ...props
    } = this.props;

    const handleClick = () => {
      if (beforeLogin && beforeLogin() === false) {
        return;
      }

      triggerLogin();
    };

    return (
      <FacebookButton
        {...props}
        onClick={handleClick}
        data-testid={dataTestId}
      >
        {children}
      </FacebookButton>
    );
  }
}

export default SocialLogin(SocialButton);
